export default __webpack_public_path__ + "media/globalBillingHubPreview2.384ec.png";